import { render, staticRenderFns } from "./no-discount.vue?vue&type=template&id=63bf33eb&scoped=true&"
import script from "./no-discount.vue?vue&type=script&lang=js&"
export * from "./no-discount.vue?vue&type=script&lang=js&"
import style0 from "./no-discount.vue?vue&type=style&index=0&id=63bf33eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bf33eb",
  null
  
)

export default component.exports